import _classCallCheck from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MissingUrlError = /*#__PURE__*/function (_Error) {
  _inherits(MissingUrlError, _Error);

  var _super = _createSuper(MissingUrlError);

  function MissingUrlError(senderType) {
    var _this;

    _classCallCheck(this, MissingUrlError);

    _this = _super.call(this, "".concat(senderType, " didn't receive upload URL"));
    _this.name = "MissingUrlError";
    return _this;
  }

  return MissingUrlError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { MissingUrlError as default };